import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['card', 'iconContainer', 'hiddenInput', 'checkbox'];

  connect() {
    // Initialize the checked state based on the data attribute only if iconContainer exists
    if (this.hasIconContainerTarget) {
      this.isChecked = this.iconContainerTarget.dataset.checked === 'true';
      this.teacherId = this.hasHiddenInputTarget ? this.hiddenInputTarget.dataset.teacherId : null;
      this.virtualClassroomId = this.hasHiddenInputTarget
        ? this.hiddenInputTarget.dataset.virtualClassroomId
        : null;
    }
  }

  toggleBackground(event) {
    const checked = event.target.checked;

    this.cardTarget.classList.toggle('tw-bg-primary-25', checked);
    this.cardTarget.classList.toggle('tw-bg-white', !checked);
    this.cardTarget.classList.toggle('tw-border-primary-200', checked);
    this.cardTarget.classList.toggle('tw-border-coolGray-400', !checked);
  }

  toggleCheckbox(event) {
    event.stopPropagation();

    // Toggle the checked state
    this.isChecked = !this.isChecked;

    // Update the visual checkbox
    this.updateCheckboxVisual();

    // Update the hidden input for form submission
    if (this.hasHiddenInputTarget) {
      if (this.isChecked) {
        this.hiddenInputTarget.value = this.teacherId || this.virtualClassroomId;
        this.hiddenInputTarget.disabled = false;
      } else {
        this.hiddenInputTarget.value = '';
        this.hiddenInputTarget.disabled = true;
      }
    }

    // Update card background
    this.updateCardBackground();
  }

  toggleSelection(event) {
    // If clicking on the card but not the checkbox area, toggle the checkbox
    if (!event.target.closest('[data-action*="toggleCheckbox"]')) {
      if (this.hasCheckboxTarget) {
        this.checkboxTarget.checked = !this.checkboxTarget.checked;
        this.checkboxTarget.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        this.toggleCheckbox(event);
      }
    }
  }

  updateCheckboxVisual() {
    if (this.hasIconContainerTarget) {
      if (this.isChecked) {
        // Show checked state with Icon component checkbox
        this.iconContainerTarget.innerHTML = `
          <div class='tw-relative tw-w-fit tw-h-fit' data-controller="icon--controller">
            <svg width="25" height="25" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="32" height="32" rx="16" fill="#4DAACA"/>
              <path d="M9.75 16.625L14.75 21.625L22.25 10.375" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        `;
      } else {
        // Show unchecked state - empty circle
        this.iconContainerTarget.innerHTML = `
          <div class="tw-w-[25px] tw-h-[25px] tw-rounded-full tw-border-2 tw-border-solid tw-border-coolGray-400 tw-bg-white"></div>
        `;
      }
    }
  }

  updateCardBackground() {
    if (this.isChecked) {
      this.cardTarget.classList.remove('tw-bg-white', 'tw-border-coolGray-400');
      this.cardTarget.classList.add('tw-bg-primary-25', 'tw-border-primary-200');
    } else {
      this.cardTarget.classList.remove('tw-bg-primary-25', 'tw-border-primary-200');
      this.cardTarget.classList.add('tw-bg-white', 'tw-border-coolGray-400');
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
}
